import { Fragment } from 'react/jsx-runtime'

import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import type { DisciplineVerzameling } from '@models/DisciplineVerzameling'

type Props = {
  disciplines: DisciplineVerzameling[]
  handleDisciplineUpdate: (discipline: DisciplineVerzameling) => void
}

export const GeschovenNaarAannemer = ({
  disciplines,
  handleDisciplineUpdate,
}: Props) => {
  return (
    <>
      {disciplines.map((discipline) => (
        <Fragment key={discipline.disciplineCode + discipline.netbeheerderCode}>
          <FormControlLabel
            label={`${discipline.disciplineLabel}`}
            sx={{
              m: 2,
            }}
            control={
              <Switch
                checked={Boolean(discipline.isGeschovenNaarAannemer)}
                onChange={(_, checked) => {
                  handleDisciplineUpdate({
                    ...discipline,
                    isGeschovenNaarAannemer: checked,
                  })
                }}
              />
            }
          />
        </Fragment>
      ))}
    </>
  )
}
